import { euro, euroDezimal } from "./preisAnalyse.js";

/**
 * Die Fragen stammen aus der Search Console — "kosten fotobox hochzeit"
 * (782 Impressionen), "fotobox hochzeit günstig" (676) und die
 * Formulierungen mit "beste Fotobox für eine Hochzeit". Die Zahlen in den
 * Antworten kommen aus dem Katalog.
 */
export function hochzeitFaq(analyse) {
  if (!analyse) return [];

  return [
    {
      question: "Was kostet eine Fotobox für eine Hochzeit?",
      answer: `Pakete, die für ${analyse.gaeste} Gäste genug Ausdrucke liefern, beginnen bei ${euro(analyse.min)} €; die Hälfte liegt unter ${euro(analyse.median)} €. Das sind rund ${euroDezimal(analyse.proGast)} € pro Gast. Rein digitale Pakete ohne Drucker gibt es günstiger, dann fehlt aber der Ausdruck zum Mitnehmen.`,
    },
    {
      question: "Wie viele Bilder druckt eine Fotobox auf einer Hochzeit?",
      answer: `Rechnet mit zwei bis drei Ausdrucken pro Gast — bei ${analyse.gaeste} Gästen also etwa ${analyse.bedarf} Bildern. Wenn ihr ein Gästebuch führt, druckt die Box jedes Motiv zweimal: einmal für den Gast, einmal zum Einkleben. Dann verdoppelt sich der Bedarf auf rund ${analyse.bedarf * 2} Ausdrucke.`,
    },
    {
      question: "Lohnt sich eine Druck-Flatrate bei einer Hochzeit?",
      answer: `Sobald ein Gästebuch dazukommt oder mehr als 80 Gäste erwartet werden: ja. Ein festes Kontingent ist sonst oft vor Mitternacht aufgebraucht. Eine Flatrate bieten ${analyse.mitFlatrate} der ${analyse.anzahlBoxen} Fotoboxen im Vergleich.`,
    },
    {
      question: "Wann sollte die Fotobox auf der Hochzeit aufgebaut sein?",
      answer:
        "Vor dem Sektempfang. Die Miete gilt fast überall für den ganzen Tag, und gerade zu Beginn entstehen die Bilder mit den Gästen, die später nicht mehr in die Box gehen — Großeltern etwa. Die meisten Aufnahmen entstehen dann zwischen Dessert und Mitternacht.",
    },
    {
      question: "Wer baut die Fotobox bei einer Hochzeit auf?",
      answer: `Bei einer Versandbox übernehmen das meist die Trauzeugen am Vortag; der Aufbau dauert 10 bis 15 Minuten. Wer damit nichts zu tun haben möchte, nimmt einen Anbieter vor Ort — ${analyse.bauenAuf} im Vergleich liefern, bauen auf und holen wieder ab.`,
    },
    {
      question: "Wie lange im Voraus sollte man eine Hochzeits-Fotobox buchen?",
      answer:
        "Für Samstage zwischen Mai und September zwei bis drei Monate vorher. Das sind die Termine, an denen mehrere Hochzeiten gleichzeitig stattfinden und die beliebten Boxen zuerst vergeben sind. Außerhalb der Saison reichen oft zwei Wochen.",
    },
    {
      question: "Wo stellt man die Fotobox auf der Hochzeit am besten auf?",
      answer:
        "Dort, wo die Gäste vorbeikommen, aber nicht direkt neben den Lautsprechern des DJs — dort wird der Bereich vor der Box zur Tanzfläche. Zwei mal zwei Meter freie Fläche und eine Steckdose in Reichweite genügen.",
    },
    {
      question: "Welche Ausstattung ist für eine Hochzeits-Fotobox wichtig?",
      answer: `Ein Blitz statt Dauerlicht, weil abends getanzt wird und Bewegung sonst verwackelt. Dazu ein eigenes Drucklayout mit Namen und Datum (${analyse.mitEigenemLayout} Fotoboxen erlauben das) und eine Online-Galerie, damit ihr die Bilder habt, die eure Gäste mitgenommen haben (${analyse.mitGalerie} Fotoboxen).`,
    },
    {
      question: "Braucht man auf einer Hochzeit Betreuung vor Ort?",
      answer:
        "In der Regel nicht — die Gäste bedienen die Box selbst, und sie läuft den ganzen Abend durch. Sinnvoll ist Betreuung, wenn ihr sehr viele Gäste erwartet oder niemanden habt, der zwischendurch Papier nachlegen kann.",
    },
  ];
}
